import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OrdersPage } from '@/pages/orders/OrdersPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// List is the default at the bare path; the board is opt-in at `?view=board`, so either view is
// deep-linkable. An explicit `?view=` wins over the localStorage per-page preference (`order-view:orders`).
const ordersSearchSchema = z.object({
	view: z.enum(['list', 'board']).optional(),
	search: z.string().optional(),
	stageId: z.string().optional(),
	company: z.string().optional(),
	page: z.coerce.number().optional(),
	pageSize: z.coerce.number().optional(),
	type: z.enum(['chain', 'own']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/orders/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['orders.read.own', 'orders.read.all'], redirectTo: '/dashboard' }),
	component: OrdersPage,
	validateSearch: ordersSearchSchema,
});
